import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

/** fetchCustomer_NotificationsList  */
interface ICustomer_NotificationsListOutput {
  items: IDataItems[];
  paging: IPaging;
}

interface IDataItems {
  id: number;
  template: number;
  subject: string | null;
  body: string | null;
  email: string | null;
  notification: string | null;
  emailrecepient: string | null;
  customerid: number;
  viewed: number;
  datesend: string | null;
  url: string | null;
  web: string | null;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface ICustomer_NotificationsListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
}

export const fetchCustomer_NotificationsList = async (
  payload: ICustomer_NotificationsListInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/customer_notifications/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}`
  );

  let _data: ICustomer_NotificationsListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** Customer_Notifications Detail */
interface ICustomer_NotificationsDetailInput {
  id: number;
}

interface ICustomer_NotificationsDetailOutput extends Types.ResponseOutput {
  data: {
    id: number | null;
    template: number | null;
    subject: string | null;
    body: string | null;
    email: string | null;
    notification: string | null;
    emailrecepient: string | null;
    customerid: number | null;
    viewed: number | null;
    datesend: string | null;
    url: string | null;
    web: string | null;
  };
}

export const fetchCustomer_NotificationsDetail = async (
  payload: ICustomer_NotificationsDetailInput
): Promise<ICustomer_NotificationsDetailOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/customer_notifications/${payload.id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Add Customer_Notifications */
interface ICustomer_NotificationsAddInput {
  template: number | null;
  subject: string | null;
  body: string | null;
  email: string | null;
  notification: string | null;
  emailrecepient: string | null;
  customerid: number | null;
  viewed: number | null;
  datesend: string | null;
  url: string | null;
  web: string | null;
}

interface ICustomer_NotificationsAddOutput extends Types.ResponseOutput {
  data: {};
}

export const addCustomer_Notifications = async (
  payload: ICustomer_NotificationsAddInput
): Promise<ICustomer_NotificationsAddOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/customer_notifications `,

    payload
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Edit Customer_Notifications */
interface ICustomer_NotificationsEditInput {
  template: number | null;
  subject: string | null;
  body: string | null;
  email: string | null;
  notification: string | null;
  emailrecepient: string | null;
  customerid: number | null;
  viewed: number | null;
  datesend: string | null;
  url: string | null;
  web: string | null;
  id: number | null;
}

interface ICustomer_NotificationsEditOutput extends Types.ResponseOutput {
  data: {};
}

export const editCustomer_Notifications = async (
  payload: ICustomer_NotificationsEditInput
): Promise<ICustomer_NotificationsEditOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/customer_notifications/${payload.id}`,
    {
      body: payload,
    }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
